import { useMemo } from 'react';
import { ERROR_MESSAGES } from '@common/constants';

export interface CustomizedContent {
  title: string;
  description: string;
}

const contentMap: Record<string, CustomizedContent> = {
  [ERROR_MESSAGES.ORGANIZATION_INVITE_NOT_ACCEPTED]: {
    title: 'Invitation Pending',
    description:
      'Your organization invitation has not been accepted yet. Please check your email and accept the invitation to gain access.',
  },
  [ERROR_MESSAGES.INVALID_ROLE]: {
    title: 'Invalid Role',
    description:
      'Your current role does not have the necessary permissions to access this page. Please contact your administrator for assistance.',
  },
  [ERROR_MESSAGES.NOT_ORGANIZATION_MEMBER]: {
    title: 'Not a Member',
    description:
      'You are not a member of this organization. Please contact your organization administrator to request access.',
  },
};

const defaultContent: CustomizedContent = {
  title: 'Permission Denied',
  description:
    'You lack the necessary permissions to view this page. For access or support, please contact our site administrator.',
};

const useUnauthorizedContent = (message: string | null): CustomizedContent =>
  useMemo(() => contentMap[message || ''] || defaultContent, [message]);

export default useUnauthorizedContent;
